// Decode a Google-encoded polyline (precision 5) into [lon, lat] pairs
// (GeoJSON order). Port of the standard algorithm used by flutter_client's
// polyline_decoder_helper. route.geometry from /route-and-rates is encoded this way.
export function decodePolyline(encoded: string, precision = 5): Array<[number, number]> {
  if (!encoded) return [];
  const factor = Math.pow(10, precision);
  const coordinates: Array<[number, number]> = [];
  let index = 0;
  let lat = 0;
  let lng = 0;

  while (index < encoded.length) {
    let result = 1;
    let shift = 0;
    let b: number;
    do {
      b = encoded.charCodeAt(index++) - 63 - 1;
      result += b << shift;
      shift += 5;
    } while (b >= 0x1f);
    lat += result & 1 ? ~(result >> 1) : result >> 1;

    result = 1;
    shift = 0;
    do {
      b = encoded.charCodeAt(index++) - 63 - 1;
      result += b << shift;
      shift += 5;
    } while (b >= 0x1f);
    lng += result & 1 ? ~(result >> 1) : result >> 1;

    // GeoJSON expects [lon, lat]
    coordinates.push([lng / factor, lat / factor]);
  }

  return coordinates;
}
